import React from "react";

const GreenButton = ({ icon: Icon, text }) => {
  return (
    <button className="w-full flex items-center py-[7px] px-[14px] text-[#00394D] rounded-[5px] bg-[#a0ff77] hover:bg-[#7af545] h-[40px] cursor-pointer">
      <span className="hidden lg:flex lg:items-center">
        <Icon className="w-[24px] h-[24px]" />
        <span
          className="ml-1 text-[14px] font-semibold leading-6"
          aria-hidden="true"
        >
          {text}
        </span>
      </span>
    </button>
  );
};

export default GreenButton;
